import React from "react";
import logo from "../../../logoBase.svg";

interface IAcxLogoLoader {
    height: number | string;
    width?: number | string;
    isSpinning: boolean;
}

export default function AcxLogoLoader(props: IAcxLogoLoader) {
    // Inline keyframes for blinking
    const blinkingKeyframes = `@keyframes acx-blinking { 50% { opacity: 0; } }`;
    // Inject keyframes once per page (idempotent)
    if (
        typeof document !== "undefined" &&
        !document.getElementById("acx-blinking-keyframes")
    ) {
        const style = document.createElement("style");
        style.id = "acx-blinking-keyframes";
        style.innerHTML = blinkingKeyframes;
        document.head.appendChild(style);
    }
    return (
        <img
            alt=""
            src={logo}
            style={{
                animationName: "acx-blinking",
                animationDuration: "2s",
                animationIterationCount: props.isSpinning ? "infinite" : "0",
                animationTimingFunction: "linear",
                height: props.height,
                width: props.width,
            }}
        />
    );
}
